const numberInputStyles = theme => ({
  // TODO: box-shadow can't be specified inline with Tailwind v2 JIT mode :/
  '.number-input-text': {
    boxShadow: `0px 0px 0px 1px ${theme('colors.grey.40')}`,

    '&.number-input-text-disabled': {
      boxShadow: `0px 0px 0px 1px ${theme('colors.grey.25')}`,
    },

    '&.number-input-text-focus': {
      boxShadow: `0px 0px 0px 2px ${theme('colors.grey.40')}`,
    },

    '&.number-input-text-invalid': {
      boxShadow: `0px 0px 0px 2px ${theme('colors.alertred.60')}`,
    },
  },
});

module.exports = { numberInputStyles };
